import { withSearch } from '@elastic/react-search-ui';
import ToggleCheckboxFilter from '../../../components/filter/ToggleCheckboxFilter';
import { css } from '@linaria/core';

const wrapper = css`
  margin-bottom: 20px;

  @media (max-width: 1080px) {
    padding-top: 20px;
  }
`;

function HARNewEntriesFilter({ filters, setFilter, removeFilter }) {
  return (
    <div className={wrapper}>
      <ToggleCheckboxFilter
        fieldId="newEntries"
        filters={filters}
        id="new-entries"
        label="New Entries"
        removeFilter={removeFilter}
        setFilter={setFilter}
      />
    </div>
  );
}

export default withSearch(({ filters, setFilter, removeFilter }) => ({
  filters,
  setFilter,
  removeFilter,
}))(HARNewEntriesFilter);
